import { configureStore } from "@reduxjs/toolkit";
import userReducer, {
  logout,
  setAccessTokenState,
} from "./auth/userSlice";
import JobCardReducer from "./jobinv/JobCardSlice";
import { allApi } from "./jobinv/AllApi";
import colorReducer from "../features/jobinv/colorSlice";
import reportReducer from "./jobinv/reportSlice";
import { machineApi } from "./jobinv/MachineApi";
import {
  subscribeToAccessToken,
  subscribeToForcedLogout,
  getAccessToken,
} from "utils/tokenService";

const store = configureStore({
  reducer: {
    user: userReducer,
    color: colorReducer,
    JobCard: JobCardReducer,
    report: reportReducer,
    [allApi.reducerPath]: allApi.reducer,
    [machineApi.reducerPath]: machineApi.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    return getDefaultMiddleware().concat(allApi.middleware, machineApi.middleware);
  },
  devTools: process.env.NODE_ENV !== "production",
});

export default store;

const initialToken = getAccessToken();
if (initialToken) {
  store.dispatch(setAccessTokenState(initialToken));
}

subscribeToAccessToken((token) => {
  store.dispatch(setAccessTokenState(token));
});

subscribeToForcedLogout(() => {
  store.dispatch(logout());
});

export {
  useFetchJobcardsQuery,
  useFetchTopCardCountQuery,
  useFetchJobcardsCompletedQuery,
  useGetCompanyNameFromJobcardQuery,
  useFetchClientJobQuery,
  useFetchCoordinatorsJobQuery,
  useFetchDeliveryDateJobQuery,
  useGetJobcardQuery,
  useGetClientsQuery,
  useFetchUsersQuery,
  useGetDropdownsQuery,
  useCreateJobcardMutation,
  useCreateJobcardVersionMutation,
  useUpdateJobcardMutation,
  useFetchInventoryQuery,
  useFetchInventoryFilterOptionsQuery,
  useFetchInventoryClothTypesQuery,
  useCreateInventoryMutation,
  useUpdateInventoryMutation,
  useFetchCapsQuery,
  useFetchColorsQuery,
  useUpdateCapMutation,
  useCreateCapMutation,
  useFetchManufacture_capQuery,
  useUpdateManufacturerMutation,
  useGetManufacture_capQuery,
  useGetCompanyNameFromJobcardCompletedQuery,
  useUploadJobcardImagesMutation,
  useFetchDesignerJobcardsQuery,
  useGetJobcardImageDetailQuery,
  useUpdateJobcardImagesMutation,
  useUpdateSingleJobcardImageMutation,
  useGetJobcardInvoicesQuery,
  useUploadJobcardInvoicesMutation,
  useDeleteJobcardInvoiceMutation,
  useDeleteJobcardImageMutation,
  useFetchDispatchDetailsQuery,
  useFetchJobcardActivityLogQuery,
  useFetchInventoryActivityLogQuery,
  useGetDigitizerUsersQuery,
  useAssignDigitizerMutation,
  useLazyFetchStockSummaryReportQuery,
  useLazyFetchLowStockReportQuery,
  useLazyFetchProcurementReportQuery,
  useLazyFetchManufacturingUsageReportQuery,
  useLazyFetchProcurementAuditReportQuery,
  useLazyFetchInventoryValuationReportQuery,
  useLazyFetchStockSummaryDatewiseReportQuery,
  useLazyFetchUsageDatewiseReportQuery,
} from "./jobinv/AllApi";


export {
  useFetchMachinesQuery,
  useGetMachineQuery,
  useCreateMachineMutation,
  useUpdateMachineMutation,
  useDeleteMachineMutation,
} from "./jobinv/MachineApi";